export default __webpack_public_path__ + "static/media/05.824630f9.webp";